import { render, staticRenderFns } from "./NavigationMenu.vue?vue&type=template&id=8da8db1a&scoped=true&"
import script from "./NavigationMenu.vue?vue&type=script&lang=ts&"
export * from "./NavigationMenu.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationMenu.vue?vue&type=style&index=0&id=8da8db1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da8db1a",
  null
  
)

/* custom blocks */
import block0 from "./NavigationMenu.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports